var map = {
	"./black-paper.png": 5710,
	"./blue-paper.png": 5319,
	"./brown-paper.png": 3793,
	"./darkwhite-paper.png": 3531,
	"./green-paper.png": 5273,
	"./lightbrown-paper.png": 3666,
	"./white-paper.png": 3890,
	"./yellow-paper.png": 1270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1296;